import * as AesirApi from './api/aesirApi'

import { fetchFromLocalStorage } from 'store'
import { getClient as getChatClient } from 'services/yggdrasil/chat/chatClient'

export const getCurrentMemberId = () => fetchFromLocalStorage('userId', 0)

export function sendAgreementRequestForExisting (slug) {
    return AesirApi.postToAesir(`agreements/${slug}/member/existing`, {})
}

export function sendAgreementRequestForNew (slug, trialForm) {
    return AesirApi.postToAesir(`agreements/${slug}/member/new`, trialForm, false)
}

export function sendTrial (slug, trialForm) {
    return AesirApi.postToAesir(`trialorders/${slug}`, trialForm, false)
}

export function sendFreeSubscription (formSlug, freeSubscriptionForm) {
    return AesirApi.postToAesir(`subscriptions/${formSlug}/join/new`, freeSubscriptionForm, false)
}

export function sendFreeSubscriptionRequestForExisting (formSlug) {
    return AesirApi.postToAesir(`subscriptions/${formSlug}/join/existing`)
}

export async function CreateWatchList (watchlistDetails, courses, collections, learningPaths) {
    return AesirApi.postToAesir('watchlists', {
        ...watchlistDetails,
        courses: courses,
        collections: collections,
        learningPaths: learningPaths
    })
}

export async function UpdateWatchList (watchlistId, watchlistDetails, courses, collections, learningPaths) {
    return AesirApi.putToAesir(`watchlists/${watchlistId}`, {
        id: watchlistId,
        ...watchlistDetails,
        courses: courses,
        collections: collections,
        learningPaths: learningPaths
    })
}

export async function DeleteWatchList (watchlistId) {
    return AesirApi.deleteFromAesir(`watchlists/${watchlistId}`)
}

export async function ShareWatchList (watchlistId, userId, mode, subordinates) {
    return AesirApi.postToAesirWithoutMember(
        `users/${userId}/watchlists/${watchlistId}/share`,
        {
            'mode': mode,
            'target': subordinates
        },
        AesirApi.applyLoggedInValidationToConfig()
    )
}

export async function UpsertNote (courseId, content) {
    return AesirApi.postToAesir(`notes/course/${courseId}`, { content })
}

export async function DeleteNote (noteId) {
    return AesirApi.deleteFromAesir(`notes/${noteId}`)
}

export async function saveVideoLogForCourseAndVideo (courseId, videoId, objToSave) {
    return AesirApi.postToAesir(`videologs/courses/${courseId}/video/${videoId}`, objToSave)
}

export async function Login (email, password) {
    return AesirApi.postToAesirWithoutMember('login', { email, password })
}

export async function loginWithSSOAuthorizationCode (code, providerId) {
    return AesirApi.postToAesirWithoutMember('login/sso', {
        providerId: providerId,
        authorizationCode: code
    })
}

export async function logout () {
    return AesirApi.postToAesirWithoutMember('logout')
}

export async function changePassword (password, token) {
    return AesirApi.postToAesirWithoutMember('users/password-reset', { password, token })
}

export async function changePasswordRequest (email) {
    return AesirApi.postToAesirWithoutMember('users/password-reset-request', { email })
}

export async function ChangePasswordFromUserInfo (passwordInfo) {
    return AesirApi.postToAesir(`password-update`, passwordInfo)
}

export async function addNoQuizCertificate (courseId) {
    return AesirApi.postToAesir(`certificates/courses/${courseId}/noquiz`)
}

export async function setMetadata (key, value) {
    return AesirApi.postToAesir(`metadata`, {
        key, value
    })
}

export async function UpdateUserInfo (userInfo) {
    return AesirApi.patchToAesir('', {
        firstName: userInfo.firstName,
        lastName: userInfo.lastName,
        jobTitle: userInfo.jobTitle
    })
}

export async function hideOrRestoreUncompletedCourseFromList ({ courseId, isHidden }) {
    return AesirApi.patchToAesir(`courses/${courseId}`, {
        hiddenInUnfinishedCoursesList: isHidden
    })
}

export async function hideOrRestoreUncompletedLearningPathFromList ({ learningPathId, isHidden }) {
    return AesirApi.patchToAesir(`learning-paths/${learningPathId}`, {
        hiddenInUnfinishedList: isHidden
    })
}

export async function joinUsingJoinToken (token) {
    return AesirApi.postToAesirWithoutMember(`users/join-by-token`, {
        token
    })
}

export async function checkResetPasswordTokenValidity (token) {
    return AesirApi.postToAesirWithoutMember(`users/check-token-validity`, {
        token
    })
}

export async function SignUpForDigitalClassRoom (courseId, eventId) {
    return AesirApi.postToAesir(`digital-classrooms/${courseId}/trainings/${eventId}/subscribe`, {})
}

export async function CancelSignUpForDigitalClassRoom (courseId, eventId, subscriptionId) {
    return AesirApi.patchToAesir(`digital-classrooms/${courseId}/trainings/${eventId}/subscriptions/${subscriptionId}/cancel`, {})
}

export const userMetadataKeys = {
    language: 'language'
}

export async function SendCourseRating (courseId, rating) {
    return AesirApi.postToAesirWithoutMember(`courses/${courseId}/ratings`, rating)
}

export async function subscribeToLearningPath (learningPathId) {
    return AesirApi.postToAesir(`learning-paths/${learningPathId}/subscribe`, {})
}

export async function unSubscribeToLearningPath (learningPathId) {
    return AesirApi.postToAesir(`learning-paths/${learningPathId}/unsubscribe`)
}

export async function createLearningPathCertificate (learningPathId) {
    return AesirApi.postToAesir(`certificates/learning-paths/${learningPathId}`)
}

export async function OpenNewChatSession () {
    return getChatClient().OpenNewChatSession()
}

export async function SendMessage (chatId, message) {
    return getChatClient().SendMessage({
        content: message.message,
        language: message.language
    }, chatId)
}

export async function SendChatBotFeedBack (messageId, chatId, feedbackPayload) {
    return getChatClient().SendChatBotFeedBack(messageId, chatId, feedbackPayload)
}

export async function RefreshChatToken () {
    return AesirApi.postToAesir('security/refresh-chat-token')
}
